const l = typeof navigator < "u" && "locks" in navigator, k = (t, r, s = {}) => l ? async (...e) => {
  const { timeout: o, onTimeout: n, ...a } = s;
  if (!o)
    return navigator.locks.request(t, a, async () => await r(...e));
  const i = new AbortController(), u = setTimeout(() => i.abort(), o);
  try {
    return await navigator.locks.request(
      t,
      {
        ...a,
        signal: i.signal
      },
      async () => await r(...e)
    );
  } catch (c) {
    c instanceof DOMException && c.name === "AbortError" && (n == null || n(new Error(`Lock "${t}" timed out after ${o}ms`)));
    return;
  } finally {
    clearTimeout(u);
  }
} : r;
export {
  l as navigatorLockSupported,
  k as withLock
};
